import { createSelector } from 'reselect';

export const authRequestSelector = state => state.get('authentication').get('auth_request');

export const stageSelector = state => state.get('authentication').get('stage');

export const tokenSelector = state => state.get('authentication').get('token');

export const usernameSelector = state => state.get('authentication').get('username');
